// extracted by mini-css-extract-plugin
export var categories = "FeaturedCategories-module--categories--31db3";
export var category = "FeaturedCategories-module--category--ec647";
export var featuredCategories = "FeaturedCategories-module--featured-categories--da68a";
export var header = "FeaturedCategories-module--header--5aea2";